import { Container, Row } from "reactstrap";
import ProfileGreeting from "./ProfileGreeting/ProfileGreeting";
import Statistics from "./Statistics/Statistics";
import { useAppSelector } from "../../ReduxToolkit/Hooks";
import UsersTable from "./UsersTable/UsersTable";
import SubscribeAlert from "../Pricing/Alert";
import { Fragment } from "react/jsx-runtime";
import AdminStatistics from "./AdminStatistics/AdminStatistics";
import { useEffect, useState } from "react";
import { getUserListAction } from "../../Api/auth";
import { toast } from "react-toastify";
import PatientsTable from "./PatientsTable/PatientsTable";
import { getPatientListAction } from "../../Api/patient";
import { getTotal } from "../../Api/patient";

const DashboardContainer = () => {
  const user = useAppSelector(state => state.user)
  const [users, setUsers] = useState<any>([]);
  const [patients, setPatients] = useState<any>([]);
  const [totalClinians, setTotalClinians] = useState(0)
  const [totalPatients, setTotalPatients] = useState(0)
  const [totalReports, setTotalReports] = useState(0)
  const [totalTemplates, setTotalTemplates] = useState(0)

  const getUsers = async () => {
    try {
      const response = await getUserListAction();
      if (response.status === 'success') {
        const _users = response.payload
        user.role === "admin" && setUsers(_users.filter((u: any) => u.role === "clinician")) 
      }
      else {
        if (response.response)
          toast.error(response.response.data.message)
        else
          toast.error("Get user list Error!")
      }
    } catch (error) {
      toast.error("Get user list failed!");
    }
  }

  const getPatients = async () => {
    try {
      const response = await getPatientListAction();
      if (response.status === 'success') {
        const _patients = response.payload
        setPatients(_patients)
      }
      else {
        if (response.response)
          toast.error(response.response.data.message)
        else
          toast.error("Get user list Error!")
      }
    } catch (error) {
      toast.error("Get user list failed!");
    }
  }

  const getTotalAnalytics = async () => {
    try {
      const response = await getTotal();
      if (response.status === "success") {
        setTotalClinians(response.payload.totalClinicians)
        setTotalPatients(response.payload.totalPatients)
        setTotalReports(response.payload.totalReports)
        setTotalTemplates(response.payload.totalTemplates)
      }
    } catch (error) {
      toast.error("Get analytics data failed!");
    }
  }

  useEffect(() => {
    getPatients()
    if (user.role === "admin") {
      getUsers();
      getTotalAnalytics();
    }
  }, [user])

  return (
    <Container fluid className="default-dashboard dashboard-2">
      <Row className="widget-grid">
        {user.role === "admin" ?
          <Fragment>
            <AdminStatistics users={users} clinicians={totalClinians} patients={totalPatients} reports={totalReports} templates={totalTemplates} />
            <UsersTable users={users} setUsers={setUsers} />
          </Fragment> :
          <Fragment>
            <Statistics />
            <PatientsTable patients={patients} setPatients={setPatients} />
          </Fragment>
        }
      </Row>
    </Container>
  );
};

export default DashboardContainer;
